import { AllowedParams, LookupItem, Product, Store } from "@/lib/types";
import { format, isValid } from "date-fns";
import { de } from "date-fns/locale";
import { isObject } from "lodash";
import { ReadonlyURLSearchParams } from "next/navigation";
import { dates, DEFAULT_HANDY_GAIN, statusClass } from "./state";

const italicMessage = (message: string) => {
  return `<i>${message}</i>`;
};

export const errorsParserv2 = (error: { errors?: object | string; message?: string }) => {
  try {
    if (isObject(error.errors)) {
      let message = "";
      for (const [key, value] of Object.entries(error.errors)) {
        message += `${key}: ${value}<br />`;
      }
      return message + " <br /> <br /> " + italicMessage(error.message ?? "");
    } else if (typeof error.errors === "string") {
      return error.errors + " <br />  <br /> " + italicMessage(error.message ?? "");
    } else if (typeof error.message === "string") {
      return error.message;
    } else return "Unknown Error";
  } catch (error) {
    return "Unknown Error";
  }
};

export const errorsParserv3 = (error: { errors?: object | string; message?: string; requestId?: string }, t?: any) => {
  let parsedError: { title: string; description: string; requestId?: string } = {
    title: t ? t("error") : "Error",
    description: t ? t("unknown_error") : "Unknown Error",
  };
  try {
    if (isObject(error.errors)) {
      let message = "";
      for (const [key, value] of Object.entries(error.errors)) {
        message += `${key}: ${value}, `;
      }
      parsedError = {
        title: message,
        description: error.message ?? "",
      };
    } else if (typeof error.errors === "string") {
      parsedError = {
        title: error.errors,
        description: error.message ?? "",
      };
    } else if (typeof error.message === "string") {
      parsedError = {
        title: error.message,
        description: "",
      };
    }

    // Backend response header'ından gelen x-request-id — destek taleplerinde
    // logları eşleştirebilmek için alert içinde kopyalanabilir gösteriliyor.
    if (error?.requestId) parsedError.requestId = error.requestId;

    return parsedError;
  } catch (error) {
    return parsedError;
  }
};

export const fPrice = (c: any, p: any) => {
  let symbol = "";
  let price = p || 0;
  price = Number(price).toFixed(2);
  switch (c) {
    case "usd":
      symbol = "$ " + price;
      break;
    case "USD":
      symbol = "$ " + price;
      break;
    case "EUR":
      symbol = price + " €";
      break;
    case "eur":
      symbol = price + " €";
      break;
    case "TRY":
      symbol = price + " ₺";
      break;
    case "try":
      symbol = price + " ₺";
      break;
    default:
      symbol = price + " €";
      break;
  }
  return symbol;
};

export const paramstoQuery = (params: string | null) => {
  //sistemdeki nav itemlar için
  const queryParams: any = {};
  if (params) {
    params.split(",").forEach((item: any) => {
      const [key, value] = item.split(":");
      queryParams[key] = value;
    });
  }
  return queryParams;
};

export const searchParamstoQuery = (params: ReadonlyURLSearchParams) => {
  //next search params için
  return Object.fromEntries(params.entries());
};

export const returnDateFormatter = (date: any) => {
  const datePart = date.match(/\d+/g);
  return datePart[0] + "." + datePart[1] + "." + datePart[2];
};

export const utcTodate = (utc: any) => {
  const newdate = new Date(utc * 1000);
  let dd: any = newdate.getDate();
  let mm: any = newdate.getMonth() + 1;
  let hh: any = newdate.getHours();
  let ii: any = newdate.getMinutes();
  let ss: any = newdate.getSeconds();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  if (hh < 10) {
    hh = "0" + hh;
  }
  if (ii < 10) {
    ii = "0" + ii;
  }
  if (ss < 10) {
    ss = "0" + ss;
  }
  return `${hh}:${ii}`;
};

export const apiCreate = (query: Record<string, string | string[] | undefined>, ago?: boolean, token?: string, basic?: { p: boolean; d: boolean }) => {
  const START = query.start?.toString() ?? (ago ? dates.ago : undefined);
  const END = query.end?.toString() ?? (ago ? dates.today : undefined);
  const PAGINATE = (query.paginate ?? 50).toString();
  const PAGE = (query.page ?? 1).toString();

  ///////Kaydedilmemiş parametreleri ve boş olanları filtreleme
  const filteredQuery: Record<string, string> = Object.keys(query).reduce(
    (acc, key) => {
      if (query[key] !== "" && query[key] !== undefined && query[key] !== null && Object.keys(AllowedParams).includes(key)) {
        acc[key] = query?.[key]?.toString() ?? "";
      }
      return acc;
    },
    {} as Record<string, string>,
  );

  //////Özel parametreler
  if (token && query.token) {
    filteredQuery[token] = query.token.toString();
  }

  //////Özel parametreler
  if (!basic || basic.p) {
    filteredQuery.paginate = PAGINATE;
    filteredQuery.page = PAGE;
  }

  //////Özel parametreler
  if (!basic || basic.d) {
    if (START) {
      filteredQuery.start = START;
    }
    if (END) {
      filteredQuery.end = END;
    }
  }

  ///////site invoice sayfasında çalışıyor
  if (query.invtype) {
    // filteredQuery.type = query.invtype === "sim" ? "801,802,105" : query.invtype === "pin" ? "201,202" : query.invtype === "provision" ? "106" : "10001,10002";
  }

  const q = new URLSearchParams(filteredQuery).toString();
  return q;
};

export const getItems = (e: any) => {
  const list = e.filter((arr: any) => arr.type !== "phone");
  return list;
};

export const getStatus = (e: any, w: any) => {
  const list = statusClass;
  const it: any = list.find(({ status }) => status === parseInt(e));
  return it[w];
};

export const setLookUp = (item: any, lookupItem: any[]) => {
  const stringItem = String(item);
  const matchingLookup = lookupItem.find((lookup) => lookup.value === stringItem);
  return matchingLookup ? matchingLookup.label : "";
};

export const getLookUp = (item: any, lookupItem: LookupItem[]) => {
  const stringItem = String(item);
  const matchingLookup = lookupItem.find((lookup) => lookup.value === stringItem);
  return matchingLookup ? matchingLookup : null;
};

export const findLookup = (lookup: any[], t: string) => {
  const foundItem = lookup.find((item) => item.slug.toLowerCase().includes(t.toLowerCase()));
  try {
    if (foundItem.list.item) {
      return foundItem.list.item;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const getParams = (params: string) => {
  const queryParams: any = {};
  if (params) {
    params.split(",").forEach((item: any) => {
      const [key, value] = item.split(":");
      queryParams[key] = value;
    });
  }
  return queryParams;
};

export const fTaxedPrice = (price: string | number, included: 0 | 1, tax: number = 19) => {
  const p = parseFloat(price?.toString());
  if (included === 1) {
    return p;
  } else {
    return p * (1 + tax / 100);
  }
};

export const fUntaxedPrice = (price: string | number, included: 0 | 1, tax: number = 19) => {
  const p = Number(price);
  if (isNaN(p)) return p;
  if (included === 0) return p;
  return (p / (1 + tax)) * 100;
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const fAddTax = (e: any, tax = 19) => {
  const p = Number(e);
  const t = Number(tax);
  const r = p + (p * t) / 100;
  return r.toFixed(2);
};

export const fOutTax = (e: any, tax = 19) => {
  const p = Number(e);
  const r = p / (1 + parseFloat(`0.${tax}`));
  return r.toFixed(2);
};

export const mScrollTo = (e: any) => {
  const target = document.getElementById(e);
  if (target) {
    target.scrollIntoView({
      behavior: "smooth",
    });
  }
};

export const fExplodePipe = (e: string) => {
  const list = e.split("|");
  const ret = [];
  list.forEach((x) => {
    if (x && (x !== "" || x !== null)) {
      ret.push(x);
    }
  });
  return list;
};

export const fDateTime = (e: string) => {
  if (e) {
    const defaultDate = e.substring(0, 10);
    const p = defaultDate.split(/\D/g);
    const d = [p[2], p[1], p[0]].join("-");
    return d + " " + e.substring(11, 19);
  } else {
    return "never";
  }
};

export const copyText = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const formatDateAndTime = (dateTimeStr: any) => {
  const date = new Date(dateTimeStr);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return {
    formattedDate: `${day}-${month}-${year}`,
    formattedTime: `${hours}:${minutes}:${seconds}`,
  };
};

export function checkLocalStorage(key: any) {
  if (typeof window !== "undefined") {
    const value = localStorage.getItem(key);
    if (value) {
      return value;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function unSlugify(slug: string): string {
  if (slug) {
    return slug
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else return slug;
}

export const slugify = (str: any) => {
  const trMap: any = {
    çÇ: "c",
    ğĞ: "g",
    şŞ: "s",
    üÜ: "u",
    ıİ: "i",
    öÖ: "o",
  };
  for (const key in trMap) {
    str = str.replace(new RegExp("[" + key + "]", "g"), trMap[key]);
  }
  return str
    .replace(/[^-a-zA-Z0-9\s]+/gi, "") // remove non-alphanumeric chars
    .replace(/\s/gi, "-") // convert spaces to dashes
    .replace(/[-]+/gi, "-") // trim repeated dashes
    .toLowerCase();
};

export function formatFileSize(bytes: number): string {
  const sizes: string[] = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
}

export function formatName(name: string): string {
  const fileParts = name.split(".");
  const fileExtension = fileParts[fileParts?.length - 1];
  return fileExtension;
}

export const getErrors = (errors: object | string) => {
  if (isObject(errors)) {
    const list = [];
    for (const [key, value] of Object.entries(errors)) {
      list.push(key);
    }
    return list;
  } else return [];
};

export function checkFileSize(thresholdSize: number, size: number, unit: "BYTE" | "KB" | "MB" | "GB" | "TB" = "BYTE"): boolean {
  // Birimleri belirleme
  const unitMap: { [key: string]: number } = {
    BYTE: 1,
    KB: 1024,
    MB: 1024 * 1024,
    GB: 1024 * 1024 * 1024,
    TB: 1024 * 1024 * 1024 * 1024,
  };

  // Gerçek dosya boyutunu ve eşik boyutunu hesaplama
  const realSize: number = size * unitMap[unit];
  const thresholdSizeBytes: number = thresholdSize * unitMap["BYTE"];

  // Gerçek boyutun eşik boyuttan büyük olup olmadığını kontrol etme
  return thresholdSizeBytes > realSize ? false : true;
}

export const convertToEnglishCharacters = (str: string) => {
  const turkishToEnglish: { [key: string]: string } = {
    ç: "c",
    ğ: "g",
    ı: "i",
    ö: "o",
    ş: "s",
    ü: "u",
    Ç: "C",
    Ğ: "G",
    İ: "I",
    Ö: "O",
    Ş: "S",
    Ü: "U",
  };

  return str.replace(/[çğıöşüÇĞİÖŞÜ]/g, (match) => turkishToEnglish[match]);
};

export function isValidHttpUrl(string: string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export const getSalesStatusColor = (lastSaleDays: Store["last_sale_status"]) => {
  if (lastSaleDays === "InActive") {
    return "bg-red-500";
  } else if (lastSaleDays === "InProgress") {
    return "bg-amber-500";
  } else {
    return "bg-emerald-500";
  }
};

export const formatDatev2 = (rawDate: string | number, customFormat?: string) => {
  const date = new Date(rawDate);
  if (!rawDate || !isValid(date)) {
    return "-";
  }

  return format(date, customFormat ?? "PPP", { locale: de });
};

export const getUserInitials = (name: string) => {
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
};

export const calculateProvision = (tarif: Product | null, selectedOptions: Product["relations"]) => {
  if (!tarif) return 0;
  const optionsTotalPrice = selectedOptions.reduce((total, rel) => {
    const isHW = rel.keywords.split(",").includes("hw");
    const price = parseFloat(rel.customer_price);

    return total + (isHW ? price : price * 1.19);
  }, 0);

  const tarifPrice = fTaxedPrice(tarif.customer_price, tarif.tax_included, parseInt(tarif.tax_rate));
  return tarifPrice + optionsTotalPrice;
};

export const getStoreAyyildizPostpaidGain = (store: Store | null | undefined) => {
  return store?.store_operator_info.find((b) => b.brand_info?.slug === "ayyildiz-postpaid")?.gain ?? DEFAULT_HANDY_GAIN;
};

export const generateClientId = () => {
  // Modern tarayıcılar
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID().replaceAll("-", "");
  }

  // crypto var ama randomUUID yok
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = crypto.getRandomValues(new Uint8Array(16)); // 128-bit
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  }

  // fallback
  let d = Date.now();
  let d2 = typeof performance !== "undefined" ? performance.now() : 0;

  return "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/x/g, () => {
    let r = Math.random() * 16;

    if (d > 0) {
      r = ((d + r) % 16) | 0;
      d = Math.floor(d / 16);
    } else {
      r = ((d2 + r) % 16) | 0;
      d2 = Math.floor(d2 / 16);
    }

    return r.toString(16);
  });
};

// Biçimli UUID v4. crypto.randomUUID yalnız güvenli bağlamda (https/localhost) var;
// getRandomValues her yerde var, sürüm/variant bitleri elle basılıyor.
export const uuidV4 = (): string => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
